<template>
	<div>
	<b-card>
		<div slot="header">
			<span style="font-size: 20px; font-weight: bold">{{$t("expenses")}}</span>
			<div class="card-header-actions">
				<b-button @click="openModal" variant="outline-primary" class="mr-2"><i class="fa fa-plus"/></b-button>
			</div>
		</div>
		<b-row>
			<b-col>
				<multiselect v-model="payload.value" :options="options" type="text"   class="multiselect-pricing" :placeholder="$t('Валюта')"/>
			</b-col>
			<b-col>
				<date-picker v-model="payload.expenseDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY"/>
			</b-col>
			<b-col>
				<multiselect :options="departments" v-model="payload.departmentId" label="name" track-by="id" :multiple="false" :allow-empty="true" :group-select="true" :show-labels="false" class="multiselect-pricing" :placeholder="$t('promo-to-product.department')"/>
			</b-col>
			<b-col cols="1">
				<b-button variant="dark" @click="search">
					<span><i class="fa fa-search"></i></span>
				</b-button>
			</b-col>
		</b-row>
		<b-row class="mt-2">
			<b-table :items="items" :fields="columns" striped hover show-empty :busy="loading" class="m-4">
				<template slot="id" slot-scope="data">
					{{ paginate(data.index, payload.page, payload.limit) }}
				</template>
				<template slot="name" slot-scope="data">
					<pre>{{ data.item.department?data.item.department.name:'' }}</pre>
				</template>
				<template slot="why" slot-scope="data">
					<span>{{data.item.dailyExpenseType ? data.item.dailyExpenseType.why :""}}</span>
				</template>
			</b-table>
			<b-col cols="12">
				<b-pagination :total-rows="total" :per-page="payload.limit" v-model="payload.page" align="center" aria-controls="table" style="margin: 0 auto"/>
			</b-col>
		</b-row>
		<b-modal v-model="ModalForm" :title="create ? 'Создать' : 'Редактировать'">
			<b-overlay>
				<b-row class="mt-2">
					<b-col cols="4">
						<b>{{$t('promo-to-product.department')}}:</b><span style="color: red">*</span>
					</b-col>
					<b-col cols="8">
						<multiselect :options="departments" v-model="form.departmentId" label="name" track-by="id" :multiple="false" :allow-empty="true" :group-select="true" :show-labels="false" class="multiselect-pricing" :placeholder="$t('promo-to-product.department')"/>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4">
						<b>Тип Расходы:</b><span style="color: red">*</span>
					</b-col>
					<b-col cols="8">
						<multiselect v-model="form.expanseTypeId" :options="Why" @search-change="listItems($event)" label="why" track-by="id" :allow-empty="true" :multiple="false" :group-select="true" :show-labels="false" class="multiselect-pricing" :placeholder="$t('Тип Расходы')"/>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4">
						<b>Время:</b><span style="color: red">*</span>
					</b-col>
					<b-col cols="8">
						<b-input-group>
							<date-picker v-model="form.expenseDate"  lang="ru" style="width: 100%; margin-left: -13px" :placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY"/>
						</b-input-group>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4">
						<b>Сумма:</b><span style="color: red">*</span>
					</b-col>
					<b-col cols="8">
						<b-form-input type="number" v-model="form.amount" :placeholder="$t('Сумма')"/>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4">
						<b>Валюта:</b><span style="color: red">*</span>
					</b-col>
					<b-col cols="8">
						<multiselect v-model="form.currencyCode" :options="options"  class="multiselect-pricing" :placeholder="$t('Валюта')"/>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4">
						<b>Коммент:</b>
					</b-col>
					<b-col cols="8">
						<b-form-input v-model="form.comment" :placeholder="$t('комментария')"/>
					</b-col>
				</b-row>

			</b-overlay>
			<template #modal-footer>
				<b-row>
					<b-col align="right">
						<b-button @click="ModalForm=false" variant="outline-danger">{{ $t('cancel') }}</b-button>
						<b-button @click="save" variant="success" class="ml-2">{{ $t('save') }}</b-button>
					</b-col>
				</b-row>
			</template>
		</b-modal>
	</b-card>
	</div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { BOverlay } from 'bootstrapVue2';
import ReferencesService from "@/services/references.sevice";
import ReportService from "@/views/analytics/otchot/report.service";
import UsersService from "@/services/users.sevice";
export default {
	name: 'Expenses',
	components: {
		BOverlay,
		Multiselect
	},
	data(){
		return {
			loading: false,
			total: null,
			departments: [],
			payload: {
				expenseDate:'',
				departmentId:null,
				page: 1,
				limit: 20,
				value: "",
			},
			Why:[],
			WhyId:null,
			items: [],
			columns: [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'amount', label: this.$t('Сумма'), class: 'text-center', sortable: true},
				{key: 'currencyCode', label: this.$t('Валюта'), sortable: true, class: 'text-center' },
				{key: 'expenseDate', label: this.$t('Время'), class: 'text-center'},
				{key: 'comment', label: this.$t('комментария'), class: 'text-center'},
				{key: 'name', label: this.$t('promo-to-product.department'), class: 'text-center'},
				{key: 'why', label: this.$t('Тип Расходы'), class: 'text-center'},
			],
			list:[],
			lists:{},
			form: {
				departmentId: null,
				expanseTypeId: null,
				amount: null,
				currencyCode: null,
				comment: '',
				expenseDate: this.getCurrentDate
			},
			options:['UZS','USD'],
			ModalForm:false,
			create:true,
		}
	},
	methods:{
		date(){
			this.form.expenseDate
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		search(){
			this.loading = true
			this.getItems();
		},
		getItems(){
			ReferencesService.getSearchExpenses(this.payload).then(res => {
				this.items = res.data.items
				this.total = res.data.total
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		listItems(search){
			if (search === ''){
				search = null
			}
			ReferencesService.getSearchExpenses2(search).then(res => {
				this.Why = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getDepartments() {
			UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		openModal() {
			this.create = true
			this.ModalForm = true
			this.form.departmentId = null;
			this.form.expanseTypeId = null;
			this.form.currencyCode = null;
			this.form.expenseDate = this.getCurrentDate;
			this.form.amount = null;
			this.form.comment = null
		},
		save() {
			if (this.form.departmentId && this.form.expanseTypeId && this.form.currencyCode && this.form.amount && this.form.expenseDate) {
				let form = Object.assign({}, this.form)
				form.departmentId = form.departmentId.id
				form.expanseTypeId = form.expanseTypeId.id
				ReferencesService.getReferenceChildrencreate(form).then(res => {
					this.$vs.notify({
						title: 'Успешно сохранено!',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
					this.ModalForm = false
					this.getItems();
				}).catch(e => {
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.$vs.notify({
					title: "заполните все обязательное поля",
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}
		}
	},
	created() {
		this.getItems()
		this.listItems('')
		this.getDepartments()
	},
	computed: {
		getCurrentDate(){
			let date = new Date()
			let day =  date.getUTCDate()
			let month = date.getMonth()+ 1
			let year =  date.getFullYear()
			return `${day}-${month}-${year}`
		},
	},
	watch: {
		'payload.page': {
			handler(){
				this.getItems();
			},
			deep: true,
		}
	}
}
</script>
